import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* updateLookbook({ payload: { id, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.lookbooks.updatePatch, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateLookbookDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateLookbookFailed,
      handledErrors,
      endpoint: api.lookbooks.updatePatch.url
    });
  }
}

export const updateLookbookSaga = takeEvery(types.UPDATE_LOOKBOOK_REQUEST, updateLookbook);